import usePlatform from "contexts/platform/use-platform"
import { ICompany, IDisplayCompany } from "platform-client/types"
import { useQuery, UseQueryResult } from "react-query"

/**
 * All the offices of a brokerage - the top level company and its child companies.
 * A user can belong to any of these offices
 */
export const useBrokerageOffices = (
  company: Pick<ICompany, "id" | "parentCompanyID"> | undefined
): UseQueryResult<IDisplayCompany[]> => {
  const platform = usePlatform()
  const rootCompanyID = company?.parentCompanyID || company?.id

  return useQuery(
    ["brokerageOffices", rootCompanyID],
    async () => {
      const [rootCompany, childCompanies] = await Promise.all([
        platform.company.getCompany(rootCompanyID as string),
        platform.company.getChildCompanies(rootCompanyID as string)
      ])

      return [rootCompany, ...(childCompanies || [])]
        .filter(Boolean)
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
    },
    { enabled: !!rootCompanyID }
  )
}
